import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31ccaf5d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=31ccaf5d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ccaf5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ccaf5d')) {
      api.createRecord('31ccaf5d', component.options)
    } else {
      api.reload('31ccaf5d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=31ccaf5d&scoped=true", function () {
      api.rerender('31ccaf5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/biz/components/ServiceMode/CommonConfirm/index.vue"
export default component.exports